import React from 'react';
import Moment from 'react-moment';
import moment from 'moment';
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from '@/components/ui/card';
import { Heading } from '@/components/ui/shared/heading';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';

export const VisitVaccinationDetails = ({
  vaccinations,
  vaccinationRef,
  handleFileDownload,
}) => {
  if (!Array.isArray(vaccinations) || vaccinations.length === 0) return null;

  return (
    <div ref={vaccinationRef}>
      {vaccinations.map((vaccination, index) => (
        <Card key={index} className="mb-4">
          <CardHeader>
            <Heading variant="userAccountDetailsTitle">Skiepai</Heading>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <span>Data: </span>
              <span>
                {new Date(Date.parse(vaccination.occurrenceDateTime)).getUTCHours() === 0 ? (
                  <Moment utc format="YYYY-MM-DD">
                    {Date.parse(vaccination.occurrenceDateTime)}
                  </Moment>
                ) : (
                  <Moment utc format="YYYY-MM-DD HH:mm">
                    {Date.parse(vaccination.occurrenceDateTime)}
                  </Moment>
                )}
              </span>
            </div>

            {vaccination.practitioner && (
              <div>
                <span>Gydytojas: </span>
                <span>
                  {vaccination.practitioner.qualification} -{' '}
                  {vaccination.practitioner.name} {vaccination.practitioner.surname}
                </span>
              </div>
            )}

            {vaccination.diagnosis && (
              <div>
                <span>Pagrindinė diagnozė: </span>
                <span>{vaccination.targetDisease}</span>
              </div>
            )}

            {vaccination.e063Status?.toString().toLowerCase() !== 'pasirasytas' && (
              <div className="text-red-600 font-medium">LAUKIAMA REZULTATŲ</div>
            )}

            {vaccination.doseQuantity && (
              <div>
                <span>Dozė: </span>
                <span>{vaccination.doseQuantity}</span>
              </div>
            )}

            {vaccination.vaccineCode && (
              <div>
                <span>Serijos numeris: </span>
                <span>{vaccination.vaccineCode}</span>
              </div>
            )}

            {vaccination.name && (
              <div>
                <span>Vakcinos pavadinimas: </span>
                <span>{vaccination.name}</span>
              </div>
            )}

            {vaccination.manufacturer && (
              <div>
                <span>Gamintojas: </span>
                <span>{vaccination.manufacturer}</span>
              </div>
            )}

            {vaccination.nextImmunizationDate && (
              <div>
                <span>Kitos vakcinos data: </span>
                <span>
                  {new Date(Date.parse(vaccination.nextImmunizationDate)).getUTCHours() === 0 ? (
                    <Moment utc format="YYYY-MM-DD">
                      {Date.parse(vaccination.nextImmunizationDate)}
                    </Moment>
                  ) : (
                    <Moment utc format="YYYY-MM-DD HH:mm">
                      {Date.parse(vaccination.nextImmunizationDate)}
                    </Moment>
                  )}
                </span>
              </div>
            )}

            {vaccination.file?.guid && (
              <div>
                <Button
                  variant="light"
                  onClick={() => {
                    const fileName = `${vaccination.vaccine} ${moment(new Date(vaccination.occurrenceDateTime)).format('YYYY-MM-DD')}`;
                    handleFileDownload(
                      'Vaccination',
                      fileName,
                      vaccination.file.type,
                      vaccination.file.guid
                    );
                  }}
                >
                  <Download />
                  Atsisiųsti PDF
                </Button>
              </div>
            )}
          </CardContent>
          <CardFooter />
        </Card>
      ))}
    </div>
  );
};
